import React, { useState } from "react";
import PropTypes from "prop-types";

import { Button, CardGroup, Divider } from "semantic-ui-react";

import InfiniteScroll from "components/InfiniteScroll";
import Popper from "components/Popper";

import { MeetingCard } from "../MeetingCard";
import { MeetingCardPlaceholder } from "../MeetingCardPlaceholder";

function MeetingsList({ meetings, onEdit, onDelete }) {
  const [popupOpen, setPopupOpen] = useState(false);

  if (meetings.totalCount === 0) {
    return null;
  }

  return (
    <Popper
      on="click"
      open={popupOpen}
      position="bottom center"
      data-test="meeting-list"
      onClose={() => {
        return setPopupOpen(false);
      }}
      style={{ padding: "0", overflow: "auto", maxHeight: "50em" }}
      trigger={
        <Button
          basic
          size="small"
          style={{
            padding: "0",
            boxShadow: "none",
            fontWeight: "bold",
            width: "100px",
            height: "20px",
            textAlign: "left",
          }}
          onClick={() => {
            return setPopupOpen(!popupOpen);
          }}
        >
          See all ({meetings?.totalCount})
        </Button>
      }
    >
      <InfiniteScroll
        loadingPage={meetings.loading}
        hasMorePages={meetings.hasMorePages}
        onLoadMore={meetings.readNext}
        style={{ display: "flex", flexDirection: "column" }}
        pullNextPageElement={
          <Button
            size="tiny"
            basic
            onClick={meetings.readNext}
            style={{
              textAlign: "center",
              alignSelf: "center",
              marginBottom: "1em",
            }}
          >
            Load More
          </Button>
        }
        loadingElement={<MeetingCardPlaceholder />}
      >
        <CardGroup style={{ margin: "0" }}>
          {meetings.data.map((meeting, idx) => {
            return (
              <div
                key={meeting.id}
                style={{ flexGrow: 1 }}
                data-test="meeting-list-item"
              >
                <MeetingCard
                  meeting={meeting}
                  key={meeting.id}
                  onEdit={(m) => {
                    onEdit(m);
                    setPopupOpen(false);
                  }}
                  onDelete={(m) => {
                    onDelete(m);
                    setPopupOpen(false);
                  }}
                />

                {idx < meetings.data.length - 1 && (
                  <Divider style={{ width: "100%", margin: "0" }} />
                )}
              </div>
            );
          })}
        </CardGroup>
      </InfiniteScroll>
    </Popper>
  );
}

MeetingsList.propTypes = {
  meetings: PropTypes.shape({
    totalCount: PropTypes.number,
    loading: PropTypes.bool,
    hasMorePages: PropTypes.bool,
    readNext: PropTypes.func,
    data: PropTypes.array,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

MeetingsList.defaultProps = {};

export default MeetingsList;
